import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import eventApi from './eventApi';

// Landing target for physical standees/QR stickers. These are printed once
// and reused across events - the qr param is a stable sticker ID that gets
// looked up against public_qr_mapping (DB-maintained) to find whichever
// event invite code it's currently pointed at, so re-targeting a sticker to
// a new event is just a DB update, no reprinting.
export default function PublicQrRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const qr = searchParams.get('qr') || '';

  useEffect(() => {
    if (!qr) { navigate('/join-event', { replace: true }); return; }
    let cancelled = false;
    eventApi.lookupPublicQr(qr)
      .then(res => {
        if (cancelled) return;
        if (res.error || !res.invite_code) { navigate('/join-event', { replace: true }); return; }
        navigate(`/join-event/${res.invite_code}`, { replace: true });
      })
      .catch(() => { if (!cancelled) navigate('/join-event', { replace: true }); });
    return () => { cancelled = true; };
  }, [qr, navigate]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: 2, textAlign: 'center', px: 3 }}>
      <CircularProgress />
      <Typography color="text.secondary">Redirecting…</Typography>
    </Box>
  );
}
